"use client";

const ButtonLoader = () => {
  return <div className="lds-dual-ring"></div>;
};

export default ButtonLoader;
